// Magic-link login для рассылок
// Контракт: wiki.telegraphyx.ru/doc/tz-beku-magic-link-dlya-rassylok-...

export type UserState =
  | 'none'
  | 'needs-yandex'
  | 'needs-requisites'
  | 'needs-payment'
  | 'no-campaigns'
  | 'active'
  | 'cancelled'
  | 'past-due'
  | 'expired'

export interface MagicLoginResponse {
  success: boolean
  redirect: string
  /**
   * Явный intent от B (contract-doc §4.4, добавлен 2026-07-28):
   *   'polls:onboard-channel' | 'polls:create' | 'polls:channel-picker' | undefined.
   * F маршрутизирует по нему; `redirect` остаётся fallback'ом для не-polls intent'ов.
   */
  intent?: string
  userState?: UserState
  campaignId?: string
  channelUUID?: string   // фактически использованный канал (из токена или fallback на бэке)
  error?: string
}

export class MagicLoginError extends Error {
  code: string
  constructor(code: string, message?: string) {
    super(message || code)
    this.code = code
  }
}

export async function magicLogin(token: string): Promise<MagicLoginResponse> {
  const res = await fetch('/api/max/auth/magic-login', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  })
  if (!res.ok) {
    let body: { error?: string } = {}
    try {
      body = await res.json()
    } catch {}
    // 401 EXPIRED_TOKEN / ALREADY_USED, 400 INVALID_TOKEN, 404 USER_NOT_FOUND
    // — все трактуем как «ссылка устарела» для юзера (бэк рекомендовал не различать)
    throw new MagicLoginError(body.error || `HTTP_${res.status}`)
  }
  return res.json()
}
